import PrivateRoute from './PrivateRoute.jsx';

export default PrivateRoute;
